import {Link} from "@tanstack/react-router";
import Message from "@/components/Message";

interface PhoneVerificationIssueMessageProps {
  onContactSupport: () => void;
}

const PhoneVerificationIssueMessage = ({
  onContactSupport,
}: PhoneVerificationIssueMessageProps) => {
  return (
    <Message type="small" closeable={true}>
      <h1 className="mb-4 text-lg font-bold">
        Pozor! Váš účet je v&nbsp;ohrožení.
      </h1>
      Stále se nám nedaří vás telefonicky ověřit. Bez toho nemůžeme dál
      spolupracovat. Prosím, upravte si své telefonní číslo v&nbsp;
      <Link to="/settings" className="underline">
        Nastavení
      </Link>{" "}
      nebo kontaktujte{" "}
      <button
        type="button"
        className="cursor-pointer underline"
        onClick={onContactSupport}
      >
        podporu
      </button>
      .
      <br />
      <br />
      V&nbsp;opačném případě se budeme muset rozloučit a&nbsp;smazat váš účet,
      což bychom opravdu neradi.
      <br />
      <br />
      Tým Trendaro
    </Message>
  );
};

export default PhoneVerificationIssueMessage;
